import {
    DefaultRootState,
    useDispatch as originalUseDispatch,
    useSelector as originalUseSelector,
    TypedUseSelectorHook,
} from 'react-redux';
import type { Action, AnyAction } from 'redux';
import type { ThunkDispatch } from 'redux-thunk';

export interface AppDispatch<A extends Action = AnyAction> extends ThunkDispatch<DefaultRootState, never, AnyAction> {
    <T extends A | A[]>(action: T): T;
}

export interface AppThunkAction<ReturnType = Promise<void>> {
    (dispatch: AppDispatch, getState: () => DefaultRootState): ReturnType;
}

export const useDispatch = (): AppDispatch => originalUseDispatch();

export const useSelector: TypedUseSelectorHook<DefaultRootState> = originalUseSelector;
